module.exports = __webpack_public_path__ + "static/media/animate-icon-lc.53156e30.svg";